export default __webpack_public_path__ + "static/media/homeBgFull.b775aa34.png";